<template >
  <div>
    <div class="back-img"/>
    <div class="opacity"/>
    <TopMenu
      :no-back="step === 1"
      no-menu
      no-background
      back-to=""
      @click="step = 1"/>
    <div class="logo">
      <a
        href="http://sqc.ca"
        target="_blank">
        <img
          src="../../assets/images/SQC_logo_signature_white.svg"
          alt="Syndicat Québécois Construction"
          width="150"
        >
      </a>
    </div>
    <div class="member-auth text-center">
      <form
        v-if="step === 1"
        class="form-member-auth"
        @submit.prevent="validate">
        <h1 class="h3 mb-3 font-weight-normal baseColor">{{ $t("MEMBER_AUTH.PAGE_LABEL") }}</h1>

        <label
          for="inputFirstName"
          class="sr-only">{{ $t("MEMBER_AUTH.FIRST_NAME_PLACEHOLDER") }}</label>
        <input
          v-validate="'required'"
          id="inputFirstName"
          v-model="firstName"
          :placeholder="$t('MEMBER_AUTH.FIRST_NAME_PLACEHOLDER')"
          :name="$t('MEMBER_AUTH.FIRST_NAME_PLACEHOLDER')"
          class="form-control top-input">
        <label
          for="inputLastName"
          class="sr-only">{{ $t("MEMBER_AUTH.LAST_NAME_PLACEHOLDER") }}</label>
        <input
          v-validate="'required'"
          id="inputLastName"
          v-model="lastName"
          :placeholder="$t('MEMBER_AUTH.LAST_NAME_PLACEHOLDER')"
          :name="$t('MEMBER_AUTH.LAST_NAME_PLACEHOLDER')"
          class="form-control middle-input">
        <datepicker
          v-validate="'required'"
          :placeholder="$t('MEMBER_AUTH.BIRTHDATE_PLACEHOLDER')"
          :name="$t('MEMBER_AUTH.BIRTHDATE_PLACEHOLDER')"
          :language="getLocale()"
          :format="format"
          :value="birthdate"
          :initial-view="'year'"
          input-class="form-control middle-input"
          wrapper-class="dtw-class"
          calendar-class="dtc-class"
          class="dt-class"
          @input="v => birthdate = v"/>
        <label
          for="inputLastNASNumbers"
          class="sr-only">{{ $t("MEMBER_AUTH.LAST_NAS_PLACEHOLDER") }}</label>
        <input
          v-validate="'required'"
          id="inputLastNASNumbers"
          v-model="lastNASNumbers"
          :placeholder="$t('MEMBER_AUTH.LAST_NAS_PLACEHOLDER')"
          :name="$t('MEMBER_AUTH.LAST_NAS_PLACEHOLDER')"
          class="form-control bottom-input">
        <ActionButton
          type="submit"
          class-name="btn btn-lg btn-secondary btn-block mt-4">
          {{ $t("MEMBER_AUTH.SUBMIT") }}
        </ActionButton>
        <LanguagePicker/>
      </form>
      <form
        v-if="step === 2"
        class="form-member-auth"
        @submit.prevent="submit">
        <h1 class="h3 mb-3 font-weight-normal baseColor">{{ $t("MEMBER_AUTH.PAGE_LABEL_CONFIRM_EMAIL") }}</h1>
        <p
          v-if="memberCreationInformation && memberCreationInformation.email"
          class="baseColor text-left">{{ $t("MEMBER_AUTH.INFO_EMAIL") }}</p>
        <p
          v-else
          class="baseColor text-left">{{ $t("MEMBER_AUTH.INFO_NO_EMAIL") }}</p>
        <label
          for="inputEmail"
          class="sr-only">{{ $t("MEMBER_AUTH.EMAIL_PLACEHOLDER") }}</label>
        <input
          v-validate="'required|email'"
          id="inputEmail"
          v-model="email"
          :placeholder="$t('MEMBER_AUTH.EMAIL_PLACEHOLDER')"
          :name="$t('MEMBER_AUTH.EMAIL_PLACEHOLDER')"
          type="email"
          class="form-control">
        <ActionButton
          type="submit"
          class-name="btn btn-lg btn-secondary btn-block mt-4">
          {{ $t("MEMBER_AUTH.CONFIRM") }}
        </ActionButton>
        <LanguagePicker/>
      </form>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { en, fr } from 'vuejs-datepicker/dist/locale';
import moment from 'moment';
import TopMenu from '@/components/Menu/TopMenu';
import TextLink from '@/components/Utils/TextLink';
import ActionButton from '@/components/Actions/ActionButton';
import LanguagePicker from '@/components/Utils/LanguagePicker';
import Copyright from '@/components/Utils/Copyright';
import Datepicker from 'vuejs-datepicker';

export default {
  name: 'MemberAuthentication',
  components: {
    ActionButton,
    Copyright,
    LanguagePicker,
    TextLink,
    TopMenu,
    Datepicker,
  },
  data() {
    return {
      step: 0,
      firstName: '',
      lastName: '',
      birthdate: null,
      lastNASNumbers: '',
      email: '',
      localMemberCreationInformation: {},
      en,
      fr,
      format: 'dd MMMM yyyy',
    };
  },
  computed: {
    ...mapState('member', ['memberCreationInformation']),
    authInformations() { return {}; },
  },
  watch: {
    step: {
      handler(newVal) {
        if (newVal === 1) {
          this.$store.commit('member/memberCreationInformation', null);
          this.firstName = '';
          this.lastName = '';
          this.birthdate = null;
          this.lastNASNumbers = '';
          this.email = '';
          this.localMemberCreationInformation = {};
        }
      },
      immediate: true,
    },
    memberCreationInformation: {
      handler(newVal) {
        this.localMemberCreationInformation = newVal;
        if (newVal && newVal.email) this.email = newVal.email;
      },
      immediate: true,
    },
  },
  created() {
    this.step = 1;
  },
  methods: {
    getLocale() {
      if (this.$i18n.locale === 'fr') {
        return this.fr;
      }
      return this.en;
    },
    validate() {
      this.$validator.validate().then(() => {
        if (this.$validator.errors.items.length > 0) {
          this.$store.commit('alerts/setAlert', {
            msg: this.$t(
              `VALIDATION.${
                this.$validator.errors.items[0].rule.toUpperCase()}`,
              [this.$validator.errors.items[0].field],
            ),
          });
        } else {
          this.$store.dispatch('member/authenticationValidate', {
            firstName: this.firstName,
            lastName: this.lastName,
            birthdate: moment(this.birthdate).format('YYYY-MM-DD'),
            lastNASNumbers: this.lastNASNumbers,
          }).then(() => {
            if (!this.memberCreationInformation || !this.memberCreationInformation.memberGuid) {
              this.$store.commit('alerts/setAlert', {
                msg: 'AUTHENTICATION_CREATE.NO_MEMBER_FOUND',
              });
            } else { this.step = 2; }
          });
        }
      });
    },
    submit() {
      this.$validator.validate().then(() => {
        if (this.$validator.errors.items.length > 0) {
          this.$store.commit('alerts/setAlert', {
            msg: this.$t(
              `VALIDATION.${
                this.$validator.errors.items[0].rule.toUpperCase()}`,
              [this.$validator.errors.items[0].field],
            ),
          });
        } else {
          this.$store.dispatch('member/authenticationCreate', {
            email: this.email,
            memberGuid: this.memberCreationInformation.memberGuid,
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
.back-img {
  background-image: url("../../assets/images/background_image_login.jpg");
  background-size: cover;
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: -1;
  background-position: center;
}
.opacity {
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  width: 100%;
  top: 0;
  z-index: -1;
}
.logo {
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-align: center;
  -ms-flex-pack: center;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  background-color: $primary;
  width: 175px;
  margin-left: auto;
  margin-right: auto;
}
div {
  &.member-auth {
    min-height: 100%;
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    -ms-flex-align: center;
    -ms-flex-pack: center;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    padding-top: 10px;
    padding-bottom: 40px;
  }
}
.form-member-auth {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: 0 auto;
}
.form-member-auth .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 20px;
  background-color: $base;
}
.form-member-auth .form-control:focus {
  z-index: 2;
}
.form-member-auth .top-input {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.form-member-auth .middle-input {
  margin-bottom: -1px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.form-member-auth .bottom-input {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>
